import { TFunction } from 'i18next';
import * as Yup from 'yup';

import { i18n } from '@sternum/web/services/i18n';

import { createDashboardNameValidation } from '../../validation';

export const createDashboardValidation = (t: TFunction = i18n.t) =>
  Yup.object().shape({
    name: createDashboardNameValidation(t, { fieldName: 'name' }),
  });
